/**
 * Stock level component
 * 
 * @module stock-level
 * @version 3.0.0
 * @extends HTMLElement
 */
 class stockLevel extends HTMLElement {

    /**
     * Stock level web component.
     * 
     * @constructor
     */
    constructor() {

        super();
        
        // For product cards, content is pre-rendered in Liquid
        if (this.dataset.variantId) {
            // No initialization needed - content already rendered
            return;
        }
        
        // For product pages, listen for variant changes
        if (this.dataset.handle) {
            window.theme.product.loadProduct(this.dataset.handle, true).then(product => {
                // loadProduct resolves null on a failed or throttled /products fetch
                if (!product) return;

                this.initEvents(product);
            });
        }

    }

    /**
     * Init events.
     * 
     * @returns {undefined}
     * @param {object} product A product object.
     */
    initEvents(product) {
        // Only listen for variant changes
        // Content is pre-rendered in Liquid, no initial render needed
        window.addEventListener('variant-change', this.onVariantChange.bind(this));
    }

    /**
     * On variant change.
     * 
     * @param {object} event Event.
     * @returns {undefined}
     */
    onVariantChange(event) {

        if(event.detail.product.handle == this.dataset.handle){
            const variantId = event.detail.variant.id;
            
            // Show/hide the appropriate variant stock level wrapper
            const allWrappers = document.querySelectorAll('.variant-stocklevel-wrapper');
            allWrappers.forEach(wrapper => {
                if (wrapper.dataset.variantId == variantId) {
                    wrapper.classList.remove('hidden');
                } else {
                    wrapper.classList.add('hidden');
                }
            });
        }
    }

    /**
     * Render Stock level
     * 
     * @param {object} variant Object selected variant
     * @returns {undefined}
    */
    render(variant) {
        // Since content is pre-rendered in Liquid, we don't need to update HTML here
        // The variant change handler already shows/hides the appropriate wrapper
        // This method is kept for compatibility but simplified
    }
}

customElements.define('stocklevel-component', stockLevel);
